import { createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { ReactElement } from 'react';
import { formatArticleTip } from '../../util/articleTipFormatter';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    articleTip: {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: '#e8f4f8',
      padding: theme.spacing(2),
      margin: theme.spacing(3, 0),
      lineHeight: theme.spacing(3) + 'px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    articleTipIcon: {
      alignSelf: 'flex-start',
      display: 'flex',
      fill: theme.palette.primary.main,
      height: 35,
      marginRight: theme.spacing(3),
      minWidth: 35,
      minHeight: 35,
      stroke: theme.palette.primary.main,
      strokeWidth: 0,
      width: 35,
    },
  }),
);

export function ArticleTip({ articleTip }: { articleTip: string }): ReactElement | null {
  const classes = useStyles();

  if (!articleTip) {
    return null;
  }

  return (
    <Grid item sm={12}>
      <div className={classes.articleTip}>
        <Typography component="div" variant="body1" color="primary" className={classes.articleTipIcon}>
          <svg
            className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root"
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
            data-testid="LightbulbOutlinedIcon"
          >
            <path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z"></path>
          </svg>
        </Typography>
        <Typography component="div" variant="body1" color="textPrimary">
          {formatArticleTip(articleTip)}
        </Typography>
      </div>
    </Grid>
  );
}
